import { Description } from '../Description'

import { Row, SmartphonesImage, titleStyles, wrapperStyles } from './styles'
import { FinalProductProps } from './types'

export function FinalProduct({ image, title, subtitle }: FinalProductProps) {
  return (
    <>
      <Description
        title={title}
        titleAdditionalStyles={titleStyles}
        wrapperAdditionalStyles={wrapperStyles}
      />
      <Row>
        <Description subtitle={subtitle} />
        <SmartphonesImage {...image} sizes="100vw" width={0} height={0} />
      </Row>
    </>
  )
}
